module.exports = __webpack_public_path__ + "img/login_bg.f0267988.svg";